import React from "react";
import { Tooltip, TooltipTrigger } from "src/components/ui/tooltip";
import NoPermissionTooltip, {
  PermissionItem,
} from "src/components/NoPermissionTooltip";

interface PermissionTooltipProps {
  permissions: PermissionItem[];
  align?: "end" | "start" | "center";
  children: React.ReactNode;
}

const PermissionTooltip: React.FC<PermissionTooltipProps> = ({
  permissions,
  align,
  children,
}) => {
  const missingPermissions = permissions.filter((p) => !p.allowed);
  const isAllowed = missingPermissions.length === 0;

  if (isAllowed) {
    return <>{children}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger className="flex" disabled>
        <div className="w-full">{children}</div>
      </TooltipTrigger>

      <NoPermissionTooltip permissions={missingPermissions} align={align} />
    </Tooltip>
  );
};

export default PermissionTooltip;
